<template>
    <div class="body">
        <el-card :header="header" v-if="(action=='REJECT' || action== 'PART_REJECT' || action == 'CQSISSUED') && auditStatus == null">
            <div v-if="subtitle" style="font-weight: bolder;font-size:16px;margin: 0 16px 10px">{{ subtitle }}</div>
            <el-form label-width="80px">
                <el-form-item :label="$t('common.opinion')+':'">
                    <el-input type="textarea" :autosize="{minRows:5}" v-model="remark"></el-input>
                </el-form-item>
            </el-form>
            <el-row>
            </el-row>
            <el-row type="flex" justify="center" style="margin-top: 1em;">
                <el-button type="warning" @click="audit(action)">{{$t("common.submit")}}</el-button>
            </el-row>
        </el-card>
        <div v-if="auditStatus == 'SUCCESS'">
            <el-row type="flex" justify="center" >
                <img src="../../assets/img/auditSuccess.png" alt="SUCCESS">
            </el-row>
            <el-alert center type="success">{{$t("common.auditSuccess")}}</el-alert>
        </div>
        <div v-if="auditStatus == 'ERROR'" style="text-align: center">
            <el-row type="flex" justify="center" >
                <img src="../../assets/img/auditError.png" alt="ERROR">
            </el-row>
            <el-alert center type="error">{{msg}}</el-alert>
        </div>
    </div>
</template>

<script>
    import {localLogin} from "../../api/login";
    import {setUser} from "@/store/main";
    import taskApi from "@/api/myTask"
    import commonMethods from "@/utils/commonMethods";
    import commonFun from "@/utils/commonFun";
    import {Message} from "element-ui";

    export default {
        data: function(){
            return {
                auditStatus: null,
                action: null,
                header: '流程审批',
                subtitle: null,
                remark: '',
                taskType: null
            }
        },
        extends: commonMethods,
        beforeCreate() {
            document.getElementsByName("viewport")[0].content = "width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no"
        },
        mounted() {
            this.header = this.$route.query.title;
            this.action = this.$route.query.action;
            this.auditor = this.$route.query.auditor;
            this.needCfo = this.$route.query.needCfo;
            this.subtitle = this.$route.query.subtitle;
            this.taskType = this.$route.query.taskType;
            if (this.action == 'PASS') {
                this.audit(this.action);
            }
        },
        methods: {
            audit(status) {
                let that = this;
                if (that.taskType != "QIP" && status == "REJECT" && commonFun.isEmpty(this.remark)) {
                    return Message.error(this.$t("common.canNotBeEmpty0", [this.$t('common.opinion')]));
                }
                taskApi.commonAudit({
                    taskId: that.$route.query.taskId,
                    taskType: that.$route.query.taskType,
                    action: status,
                    title: that.$route.query.title,
                    auditor: that.$route.query.auditor,
                    comments: that.remark,
                    needCfo: that.needCfo
                }).then(res => {
                    if (res.code == 200) {
                        this.auditStatus = 'SUCCESS';
                    }
                }).catch(error => {
                    this.auditStatus = 'ERROR';
                    this.msg = error.response.data.msg;
                });
            },
            vaid(){
                let that = this;
                taskApi.commonAudit({
                    taskId: that.$route.query.taskId,
                    taskType: that.$route.query.taskType,
                    action: 'VALID',
                    auditor: that.$route.query.auditor,
                    comments: that.remark
                }).then(res => {
                    
                }).catch(error => {
                    this.auditStatus = 'ERROR';
                    this.msg = error.response.data.msg;
                });
            }
        }
    }
</script>

<style scoped>
    .body {
        width: 100%;
        height: 100%;
        background: #FFFFFF;
    }
</style>
